import { rgba } from "polished";

export const base = `#000`;
export const grey = `#c0c0c0`;
export const brown = `#e7e2da`;
export const alabaster = `#fffef2`;
export const cream = `#F6F5E8`;
export const cream2 = `#ebeade`;
export const lightGrey = `#eee`;
export const green = `rgb(124, 141, 97)`;
export const greenSecondary = `rgb(109, 123, 85)`;



// WEBPACK FOOTER //
// ./client/styles/colors.js